/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalChangeLog.vue?vue&type=template&id=039860c2&scoped=true"
import script from "./ModalChangeLog.ts?vue&type=script&lang=ts&external"
export * from "./ModalChangeLog.ts?vue&type=script&lang=ts&external"
import style0 from "./ModalChangeLog.vue?vue&type=style&index=0&id=039860c2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039860c2",
  null
  
)

export default component.exports